import Page from "../../layout/Page";
import PageNotFoundFragment from "../../fragments/PageNotFoundFragment";

const NotFoundPage = () => {
  return (
    <Page title={""} name={"404"}>
      <PageNotFoundFragment />
    </Page>
  );
};

export default NotFoundPage;
